import { IUserInit } from '../interfaces/IUserInit';
import { DashboardUserRoute } from '../types/DashboardUserRouteTypes';

export class PartnerInit implements IUserInit {
  private dashboardUserRoute: DashboardUserRoute = 'partner';

  public getDashboardUserRoute() {
    return this.dashboardUserRoute;
  }
}
